// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"o3-z","displaySixCardTiles":"p3-z"};